export class EnaioUserGroup {
    id = 0;
    name = "";
    osGuid = "";
    profileUserId = 0;
    description = "";
}
